import { render, staticRenderFns } from "./TackVideo.vue?vue&type=template&id=85691a44&scoped=true&"
import script from "./TackVideo.vue?vue&type=script&lang=js&"
export * from "./TackVideo.vue?vue&type=script&lang=js&"
import style0 from "./TackVideo.vue?vue&type=style&index=0&id=85691a44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85691a44",
  null
  
)

export default component.exports